export const subjects = [
    "Computer Science",
    "Math",
    "Physics",
    "Biology",
    "Chemistry",
    "English",
    "Social Studies",
]